
/* CSS */
import "../styles/printSize.css";

/* UTILS */
import DateFormatter from "../utils/dateFormatterUtils";
import TitleCase from "../utils/titleCaseUtils";
import titleCaseString from "../utils/titleCaseUtils";
import { useEffect, useState } from "react";

const QRCheckerNotaryAcknowledgment = ({ formData, mode = "IEN", dateReleased }) => {

    console.log("QRCheckerNotaryAcknowledgment FORMDATA", formData.images);
    const lawyerPhoto     = formData.images.find(image => image.image_name === "lawyer_photo");
    const lawyerSignature = formData.lawyer.signature


    const enp_roll_no          = formData.lawyer.enp_roll_no;
    const enp_commission_no    = formData.lawyer.enp_commission_no;
    const enp_ptr_no           = formData.lawyer.enp_ptr_no;
    const enp_ptr_issued_place = formData.lawyer.enp_ptr_issued_place;
    const enp_ibp_no           = formData.lawyer.enp_ibp_no;
    const enp_email            = formData.lawyer.enp_email;
    const enp_address          = formData.lawyer.enp_address;
    const enp_compliance_no    = formData.lawyer.enp_compliance_no;
    const enp_notary_name      = formData.lawyer.enp_notary_name;


    const enp_province     = formData.lawyer.province;
    const enp_municipality = formData.lawyer.municipality;
    const enp_barangay     = formData.lawyer.barangay;


    const enp_commission_expiry_date = new Date(formData.lawyer.enp_commission_expiry_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });
    const enp_ptr_issued_date = new Date(formData.lawyer.enp_ptr_issued_date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        timeZone: "Asia/Manila",
    });

    const raw_enp_compliance_issued_date = formData?.lawyer?.enp_compliance_issued_date;
    const enp_compliance_issued_date = raw_enp_compliance_issued_date
        ? (() => {
            const d = new Date(raw_enp_compliance_issued_date);
            return isNaN(d.getTime())
                ? ""
                : d.toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                    timeZone: "Asia/Manila",
                });
        })()
        : "";



    const lawyerFullName = `${formData.lawyer.first_name} ${formData.lawyer.middle_name ?? ""} ${formData.lawyer.last_name}`;
    const fullName = `${formData.first_party_full_name}`;
    const secondPartyFullName = `${formData.second_party_full_name ?? ""}`;


    const issuedDate = formData.attachment_id_date_issued
        ? new Date(formData.attachment_id_date_issued)
        : new Date();

    // Ensure it's a valid date
    if (isNaN(issuedDate.getTime())) {
        // If the date is invalid, fallback to the current date
        console.error("Invalid date provided, using current date instead.");
        issuedDate = new Date(); // Fallback to current date if invalid
    }

    // Format the date (Asia/Manila timezone)
    const formattedDateIssued = issuedDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",  // Abbreviated month (e.g., 'Mar')
        day: "numeric",
        timeZone: "Asia/Manila",  // Ensure timezone is respected
    });

    const issuedDateSecondParty = formData.second_party_attachment_id_date_issued
        ? new Date(formData.second_party_attachment_id_date_issued)
        : new Date();

    if (isNaN(issuedDateSecondParty.getTime())) {
        console.error('Invalid date provided.');
        issuedDateSecondParty = new Date(); // fallback to current date if invalid
    }


    const manilaDate = new Date(
        issuedDateSecondParty.toLocaleString("en-US", { timeZone: "Asia/Manila" })
    );

    const formattedDateIssuedSecondParty = manilaDate.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short", // abbreviated month (e.g., 'Jan')
        day: "numeric", // day without leading zero
        timeZone: "Asia/Manila", // ensures correct timezone
    });




    return (
        <div className="position-relative">
            <div className="a4-container text-times-new-roman p-5 position-relative bg-none">
                <div style={{
                        position: "absolute",
                        top: "7%",
                        left: "5%",
                        right: "5%",
                        bottom: "10%", 
                        //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.1,
                        zIndex: 1,
                        height: "80%",
                        width: "100%",
                    }} />
                <div style={{ position: "relative", zIndex: 10, padding: "20px", }} >
                    <div className="d-flex justify-content-between flex-row">
                        <div>
                            <div className="mb-2 d-flex flex-column">
                                <span>Republic of the Philippines )</span>
                                <span className="fw-medium">
                                    City/Municipality of {TitleCase(enp_municipality)} ) S.S.
                                </span>
                            </div>

                              <img
                                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                    alt="Logo"
                                    className="img-fluid"
                                    style={{ width: 180, height: 60 }}
                                />
                        </div>
                        <div>
                            <div className="text-start" >
                                <div className="d-inline-block text-center">
                                    <img
                                        src={`data:image/png;base64,${formData.qr_code}`}
                                        alt="QR"
                                        className="img-fluid"
                                        style={{ width: 128, height: 128 }}
                                    />
                                    <div>SERIAL NUMBER:</div>
                                    <div className="fw-bold">{formData.transaction_id}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="text-center fw-bold mt-0">ACKNOWLEDGEMENT</div>

                    <p className="mt-5">

                        On this <b>{DateFormatter(formData.date_released, 'Day of Month, YYYY')}</b>, before me, <b>{enp_notary_name?.toUpperCase()}</b>
                        , a duly commissioned <b>Electronic Notary Public</b> in and for the{" "}
                        <b>Philippines</b>, personally appeared via video conference:
                    </p>

                    <table className="table table-bordered  text-center mt-4" style={{border:"1px solid gray",color:"black"}}>
                        <thead>
                            <tr>
                                <th>
                                    <i className="fw-bold"  style={{color:"black"}}>Name of Signatory</i>
                                </th>
                                <th>
                                    <i className="fw-bold"  style={{color:"black"}}>Issued ID</i>
                                </th>
                                <th>
                                    <i className="fw-bold"  style={{color:"black"}}>ID No./ Date Issued</i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div  style={{color:"black"}}>
                                        {TitleCase(fullName.toUpperCase())}
                                    </div>
                                </td>
                                <td>
                                    <div  style={{color:"black"}}>
                                        {formData.attachment_id_type?.toUpperCase()}
                                    </div>
                                </td>
                                <td>
                                    <div  style={{color:"black"}}>
                                        {formData.attachment_id_number} / {formattedDateIssued}
                                    </div>
                                </td>
                            </tr>

                            {formData.secondPartyFirstName &&

                                <tr>
                                    <td> <div style={{color:"black"}}> {TitleCase(secondPartyFullName.toUpperCase())} </div> </td>
                                    <td> <div style={{color:"black"}}> {formData.second_party_attachment_id_type?.toUpperCase()} </div> </td>
                                    <td> <div style={{color:"black"}}> {formData.second_party_attachment_id_number} / {formattedDateIssuedSecondParty} </div> </td>
                                </tr>

                            }


                        </tbody>
                    </table>

                    <p className="mt-4">
                        who is known to me to be the same person who executed the foregoing
                        electronic document.
                    </p>
                    <p className="mt-4">
                        During the videoconference, the principal affixed his/her electronic
                        signature through the <b>Electronic Notarization Facility (ENF)</b> in
                        my full view, confirmed that the signature was voluntarily affixed for
                        the purposes stated therein, and declared that he/she electronically
                        signed the document as his/her free and voluntary act and deed.
                    </p>

                    <p className="mt-4">
                        This document was electronically notarized via <b>[Mode: {mode}]</b>,
                        in accordance with the Rules on Electronic Notarization and existing
                        laws.
                    </p>

                    <p className="fw-bold">
                        IN WITNESS WHEREOF, I hereunto affix my electronic notarial seal this
                        <b className="ms-1">{DateFormatter(formData.date_released, 'MM DD, YYYY')}</b> at <b>{TitleCase(enp_municipality)}, Philippines</b>.
                    </p>

                    

                  
                    <div className="row fw-bold">
                        <div className="col-4">
                            <div className="mt-5">
                                <p className="m-0">Doc. No.: <u>{formData.document_no ? formData.document_no : '______'}</u></p>
                                <p className="m-0">Page No.: <u>{formData.page_no ? formData.page_no : '______'} </u></p>
                                <p className="m-0">Book No.: <u>{formData.book_no ? formData.book_no : '______'} </u></p>
                                <p className="m-0">Series of <u>{DateFormatter(formData.date_released, 'YYYY')}</u></p>
                            </div>
                        </div>

                        <div className="col-8">
                            <div className="d-flex flex-column align-items-center text-center mt-4  text-primary">
                                <div className="fw-bold">Atty. {TitleCase(lawyerFullName.toUpperCase())}</div>
                                <div>Electronic Notary Public</div>
                                <div className="d-flex d-inline-block">
                                    Roll of Attorney's No.:
                                    {enp_roll_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Commission No.:
                                    {enp_commission_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Commission Expiry Date:

                                    {enp_commission_expiry_date}
                                </div>
                                <div className="d-flex d-inline-block">
                                    PTR No.:
                                    {enp_ptr_no}
                                    , issued at <b className="ms-1">{enp_ptr_issued_place}</b>, on <b className="ms-1">{enp_ptr_issued_date}</b>
                                </div>
                                <div className="d-flex d-inline-block">
                                    IBP No.:
                                    {enp_ibp_no}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Email:{enp_email}
                                </div>
                                <div className="d-flex d-inline-block">
                                    Office Address:
                                    {TitleCase(enp_address)}
                                </div>
                                <div className="d-flex d-inline-block">
                                    MCLE Compliance No.:
                                    {enp_compliance_no}
                                    , issued on <b className="ms-1"> {enp_compliance_issued_date}</b>
                                </div>
                            </div>
                        </div>
                    </div>

               


                </div>

            
                <img src="/iusevolutione/assets/img/iusevolutione/footer-logo.png" className="img-fluid m-0" style={{ position: 'absolute', bottom: 0,left:0}} />
           
            </div>



            <div className="a4-container text-times-new-roman p-5 position-relative bg-none">
                <div
                    style={{
                        position: "absolute",
                        top: "7%", // Centers the div vertically by setting the top to 10% (since height is 80%, 100% - 80% = 20%, so we divide it equally with 10% padding on top and bottom)
                        left: "5%", // Centers the div horizontally by setting the left to 5% (100% - 90% = 10%, so we divide it equally with 5% padding on both sides)
                        right: "5%",
                        bottom: "10%",
                        //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.1,
                        zIndex: 1, // Ensures the background stays behind the content
                        height: "80%", // Height set to 80%
                        width: "100%", // Width set to 90%
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 10,
                        padding: "20px",
                        height: "91%"
                    }}>

                    <div className="d-flex justify-content-between flex-row mb-4">

                        <div>
                            <div className="mb-4 d-flex flex-column">
                                <span className="fw-bold fs-5 ">ANNEX A</span>
                            </div>

                              <img
                                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                    alt="Logo"
                                    className="img-fluid"
                                    style={{ width: 180, height: 60 }}
                                />
                        </div>
                        <div>

                                  <div className="text-start" >
                                    <div className="d-inline-block text-center">
                                        <img
                                            src={`data:image/png;base64,${formData.qr_code}`}
                                            alt="QR"
                                            className="img-fluid"
                                            style={{ width: 128, height: 128 }}
                                        />
                                    </div>
                                </div>
                        </div>

                   
                    </div>

                    <div className="row mb-4 mt-4">
                        <div className="col">

                            <div className="text-center">
                                <img src={lawyerPhoto ? lawyerPhoto.image_path : '/iusevolutione/assets/img/iusevolutione/enotaryBg.png'} 
                                    alt="Lawyer3" 
                                    className="rounded border" 
                                    style={{ objectFit: "cover", height: "225px", width: "148px" }} 
                                />

                            <div className="text-center d-flex flex-column align-items-center">
                                <p className="fw-bold">NOTARY PUBLIC</p>
                                {lawyerSignature && 
                                <img
                                    src={lawyerSignature}
                                    alt="Signature"
                                    className="rounded w-220px p-0 mt-n4"
                                    height={120}
                                />}
                                <p className="text-center mt-n4" style={{ borderTop: "1px solid black" }}>
                                    <b>Atty. {titleCaseString((lawyerFullName || "").replace("N/A", "").trim())}</b>
                                </p>
                            </div>

 
                            </div>
                        </div>
                    

                    {formData.principal_image &&
                        <div  className="col text-center">
                                <img
                                    src={formData.principal_image}
                                    alt="First Party"
                                    className="rounded"
                                    height={225}
                                    width={148}
                                    style={{ objectFit: "cover" }}
                                />

                            <div className="text-center d-flex flex-column align-items-center">
                                <p className="fw-bold">FIRST PARTY</p>
                                <img
                                    src={formData.signature_file}
                                    alt="Signature"
                                    className="rounded w-220px p-0 mt-n4"
                                    height={120}
                                />
                                <p className="text-center mt-n4" style={{ borderTop: "1px solid black" }}>
                                    <b>{titleCaseString((fullName || "").replace("N/A", "").trim())}</b>
                                </p>
                            </div>
                        </div>
                    }


                        {formData.second_party_image &&
                            <div className="col">
                                <div className="text-center">
                                    {formData.second_party_image && <img src={formData.second_party_image} alt={`Valid ID`} className="rounded" style={{ objectFit: "cover", height: "275px", width: "180px" }} />}
                                    <div className="position-relative text-center" style={{ zIndex: 10 }}>
                                        <p className="mb-0"><b>SECOND PARTY</b></p>
                                        {formData.second_party_signature_file && <img src={formData.second_party_signature_file} alt={`Signature`} className="  rounded   p-0 mt-n4" style={{ objectFit: "cover", height: "120px", zIndex: "999" }} />}
                                        <p className=" text-center fw-bold fs-6 mt-n5" style={{ borderTop: "1px solid black" }}><b>{titleCaseString(secondPartyFullName)}</b></p>
                                    </div>
                                </div>
                            </div>
                        }



                    </div>





                    <div className="row mt-4">
                        <div className="fw-bold fs-4 mb-2">Witness/es</div>

                        {formData.witnesses && formData.witnesses.length > 0 &&
                            formData.witnesses
                                .filter(witness => witness.participant_fullname)  // Filter out those with null/empty participant_fullname
                                .slice(0, 3)  // Now slice the array after filtering
                                .map((witness, index) => {
                                    return (
                                        <div key={index} className="col text-center">
                                            {witness.participant_profile_photo && (
                                                <img
                                                    src={witness.participant_profile_photo}
                                                    alt="Witness"
                                                    className="rounded"
                                                    height={275}
                                                    width={180}
                                                    style={{ objectFit: "cover" }}
                                                />
                                            )}

                                            <div className="text-center d-flex flex-column align-items-center">
                                                <img
                                                    src={witness.participant_signature_path}
                                                    alt="Signature"
                                                    className="rounded w-220px p-0 mt-n4"
                                                    height={120}
                                                />
                                                <p className="text-center mt-n4" style={{ borderTop: "1px solid black" }}>
                                                    <b>{titleCaseString((witness.participant_fullname || "").replace("N/A", "").trim())}</b>
                                                </p>
                                            </div>
                                        </div>
                                    );
                                })
                        }

                    </div>


                </div>
            </div>



            <div className="a4-container text-times-new-roman p-5 position-relative bg-none">
                <div
                    style={{
                        position: "absolute",
                        top: "7%",
                        left: "5%",
                        right: "5%",
                        bottom: "10%",
                        //backgroundImage: "url('/iusevolutione/assets/img/iusevolutione/enotaryBg.png')",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                        opacity: 0.1,
                        zIndex: 1,
                        height: "80%",
                        width: "100%",
                    }}
                />

                <div
                    style={{
                        position: "relative",
                        zIndex: 10,
                        padding: "20px",
                        height: "91%",
                    }}>
                    
                    <div className="d-flex justify-content-between flex-row mb-4">
                        <div>
                            <div className="mb-4 d-flex flex-column">
                                <span className="fw-bold fs-5 ">ANNEX B</span>
                            </div>

                            <img
                                    src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png"
                                    alt="Logo"
                                    className="img-fluid"
                                    style={{ width: 180, height: 60 }}
                                />
                        </div>
                        <div>
                            <div className="text-start" >
                                <div className="d-inline-block text-center">
                                    <img
                                        src={`data:image/png;base64,${formData.qr_code}`}
                                        alt="QR"
                                        className="img-fluid"
                                        style={{ width: 128, height: 128 }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="fw-bold fs-4 mb-2">Witness/es</div>

                        {formData.witnesses && formData.witnesses.length > 0 &&
                            formData.witnesses
                                .filter(witness => witness.participant_fullname)  // Filter out those with null/empty participant_fullname
                                .length > 3 &&  // Only proceed if more than 3 witnesses remain after filtering
                                formData.witnesses
                                    .filter(witness => witness.participant_fullname)  // Filter again
                                    .slice(3)  // Only take the witnesses starting from the 4th one
                                    .map((witness, index) => {
                                    return (
                                                    <div className="col text-center">
                                                        {witness.participant_profile_photo && (
                                                            <img
                                                                src={witness.participant_profile_photo}
                                                                alt="Witness"
                                                                className="rounded"
                                                                height={275}
                                                                width={180}
                                                                style={{ objectFit: "cover" }}
                                                            />
                                                        )}

                                                        <div className="text-center d-flex flex-column align-items-center">
                                                            <img
                                                                src={witness.participant_signature_path}
                                                                alt="Signature"
                                                                className="rounded w-220px p-0 mt-n4"
                                                                height={120}
                                                            />
                                                            <p className="text-center mt-n4" style={{ borderTop: "1px solid black" }}>
                                                                <b>{titleCaseString((witness.participant_fullname || "").replace("N/A", "").trim())}</b>
                                                            </p>
                                                        </div>
                                                    </div>
                                    );
                                })
                        }
                    </div>
                </div>
            </div>



            <img src="/iusevolutione/assets/img/iusevolutione/logoWithTitle.png" alt="Logo"
                className="img-fluid ms-4 d-none"
                style={{ position: 'absolute', bottom: 0, width: 170, height: 60, marginBottom: 40 }}
            />

            <img src="/iusevolutione/assets/img/iusevolutione/enotaryFooter.png" alt="Footer"
            className="d-none"
                style={{ position: 'absolute', bottom: 0, width: '100%', height: '190px' }}
            />

        </div>

    );
};

export default QRCheckerNotaryAcknowledgment;
